import { has, includes } from 'lodash';

import { handleError } from '@/utils/exception_handler';

// STATE
export const deleteState = {
  deleting: [],
};

// GETTERS
export const deleteGetters = {
  deleting: state => state.deleting,
  isDeleting: (state, getters) => id => includes(getters.deleting, id),
};

// MUTATIONS
export const buildDeleteMutations = (mutationNames) => {
  const mutations = {};

  mutationNames.forEach((mutation) => {
    mutations[`${mutation}Pending`] = (state, id) => {
      state.deleting = state.deleting.concat(id);
    };

    mutations[`${mutation}Success`] = (state, id) => {
      // eslint-disable-next-line no-console
      console.log('deleting mutation');
      state.deleting = state.deleting.filter(itemId => (
        itemId !== id
      ));
    };

    mutations[`${mutation}Error`] = (state, { id }) => {
      state.deleting = state.deleting.filter(itemId => (
        itemId !== id
      ));
    };
  });

  return mutations;
};

// ACTIONS
export const destroy = (context, { api, endpoint, params, mutation = null, successCallback = null, errorCallback = null }) => {
  const { commit, dispatch } = context;
  const mutationPrefix = mutation || endpoint;

  if (!has(api, endpoint)) throw new Error(`Endpoint ${endpoint} not found`);

  commit(`${mutationPrefix}Pending`, [params.id]);

  return api[endpoint](params)
    .then((response) => {
      dispatch('delete', params.id);

      commit(`${mutationPrefix}Success`);

      if (successCallback) successCallback(response);

      return { status: true, data: response };
    }, handleError(context, `${mutationPrefix}Error`, errorCallback))
    .catch(handleError(context, `${mutationPrefix}Error`, errorCallback));
};



// WEBPACK FOOTER //
// ./src/store/extensions/delete.js